var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.isLink ? 'a' : 'button',{tag:"component",class:[
    'icon-button',
    `is-${_vm.size}`,
    _vm.isRed && 'is-red',
  ],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('Icon',{attrs:{"icon":_vm.icon,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }